<template>
    <div class="homeall">
  
      <div class="all">     
        <div class="home_part1">
          <b-img :src="require('@/assets/newhome_p1_720.png')" class="home_part1_image" />
        </div>
        <div class="home_part2">
          <div class="home_part2left"></div>
          <div class="home_part2_1">
            <div class="home_part2_1_1">We Believe</div>
            <div class="home_part2_1_2">We believe that a good life starts with health, and we are committed to providing global healthcare solutions. Everything we do is aimed at improving the quality of life.<br>
                                         We provide digital diabetes management solutions, changing the traditional way of treating diabetes and making diabetes management easier.</div>
          </div>
          <div class="home_part2right"></div>
        </div>
        <div class="home_part3">
          <div class="home_part3_1">
            <div class="home_part3_1_1">We Solve Problems</div>
            <div class="home_part3_1_2">Start The Journey Of Digital Diabetes Management To Make Diabetes Management Easier</div>
          </div>
        </div>
        <div class="home_part4">
          <div class="home_part4left"></div>
          <div class="home_part4_1">
            <div class="home_part4_1_1">
              <div class="home_part4_1_1_d">
                For many patients, daily life of diabetes is not easy. After measuring blood sugar, paper tests are conducted every time 
                Records are often lost or incomplete and discontinuous, and cannot be promptly sought medical attention when there are abnormal blood sugar levels at home 
                Difficulty with communication and other related issues. 
                Therefore, our digital diabetes management will help you manage diabetes more easily
              </div>
              <div class="home_part4_1_1_d_button">
                    <b-button variant="primary" to="/about" target="_blank" style="width: 249px;">
                      <div class="txt" style="margin-left: -20px;">Learn more about DDM</div>
                    </b-button>
                    <div class="jiantou">
                      <b-img  fluid :src="require('@/assets/jiantou.png')" class="jiantou1"></b-img>
                    </div>
              </div>
            </div>
            <div class="home_part4_1_2">
              <b-img  fluid :src="require('@/assets/homepic01.png')" class="home_part4_1_2-image"></b-img>
            </div>
          </div>
          <div class="home_part4right"></div>
        </div>
        <div class="home_part3">
          <div class="home_part3_1">
            <div class="home_part3_1_1">We Collaborate With Each Other</div>
            <div class="home_part3_1_2">We Integrate and Share Patient Related Data To Provide Personalized Diabetes Management Solutions</div>
          </div>
        </div>
        <div class="home_part5">
          <div class="home_part5left"></div>
          <div class="home_part5_1">
            <div class="home_part5_1_1">
              <b-img  fluid :src="require('@/assets/homep2.png')" class="home_part5_1_2-image"></b-img>
            </div>
            <div class="home_part5_1_2">
              <div class="home_part5_1_2_d">
                We will integrate and share patient data information both inside and outside the hospital into an ecosystem to provide more comprehensive medical services and health management. Helps to improve the continuity and efficiency of medical services, while providing patients with a more personalized medical experience.
              </div>
              <div class="home_part5_1_2_button">
                <b-button variant="primary" to="/ecosystem" target="_blank" style="width: 318px;">
                  <div class="txtb2" style="margin-left: -28px;">Learn more about ecosystem content</div>
                </b-button>
                    <div class="jiantou" style="margin-left: -22px;">
                      <b-img  fluid :src="require('@/assets/jiantou.png')" class="jiantou1"></b-img>
                    </div>
              </div>
            </div>
          </div>
          <div class="home_part5right"></div>
        </div>
        <div class="home_part3">
          <div class="home_part3_1">
            <div class="home_part3_1_1">We Work Closely Together</div>
            <div class="home_part3_1_2">We Have A Common Goal and Vision To Help Patients and Improve Their Quality Of Life</div>
          </div>
        </div>

        <div class="home_part4">
          <div class="home_part4left"></div>
          <div class="home_part4_1">
            <div class="home_part4_1_1">
              <div class="home_part4_1_1_d">
                All we do is to empower health. We will work closely with hospitals, medical teams and other partners. We have a common goal and vision to help diabetes patients achieve more accurate blood sugar control and improve their quality of life.
              </div>
              <div class="home_part4_1_1_d_button">
                    <b-button variant="primary" to="/about-us" target="_blank" style="width: 219px;">
                      <div class="txtb3" style="margin-left: -20px;">Learn more about us</div>
                    </b-button>
                    <div class="jiantou">
                      <b-img  fluid :src="require('@/assets/jiantou.png')" class="jiantou1"></b-img>
                    </div>
              </div>
            </div>
            <div class="home_part4_1_2">
              <b-img  fluid :src="require('@/assets/homep4.png')" class="home_part4_1_2-image"></b-img>
            </div>
          </div>
          <div class="home_part4right"></div>
        </div>
        <div class="home_part6">
          <b-img :src="require('@/assets/homep7.png')" class="home_part6_image" />
        </div>

      </div>
  
    </div>
  </template>
  
  <script>
  
  export default {
    name: 'HomePage',

  }
  </script>
  
  <style scoped>
.all{
  background-color:#F4F7FC ;
  min-width: 1200px;
}
  .b-button {
  margin-top: 10px; /* 根据需要调整按钮的上边距 */
  font-size: 1.25rem; /* 调整按钮的字体大小 */
  padding: 10px 20px; /* 调整按钮的内边距 */
}

.home_part1{
  position: relative;
  width: 100%;
  overflow: hidden;
}
.home_part1_image{
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.home_part2 {
  display: grid;
  grid-template-columns: 1fr 1200px 1fr; 
  gap: 0; 
}
.home_part2left, .home_part2right {
    
}
.home_part2_1{
  width: 1029px;
  margin-top: 70px;
}
.home_part2_1_1{
  font-family: Arial;
  font-size: 36px;
  font-weight: 700;
  line-height: 44px;
  color: #000000;

}
.home_part2_1_2{
  font-family: Arial;
font-size: 18px;
font-weight: 400;
line-height: 30px;
width: 70%; 
color: #555555;
    width: 100%; 
    margin-top: 2.22%;
}
.home_part3{
  text-align: center;
  margin-top: 64px;
}
.home_part3_1{
  width: 100%;
}
.home_part3_1_1{
  font-family: Arial;
font-size: 36px;
font-weight: 700;
line-height: 44px;
color: #000000;
}
.home_part3_1_2{
  font-family: Arial;
font-size: 16px;
font-weight: 400;
line-height: 24px;
color: #1B2944;
margin-top: 16px;
}
.home_part4 {
  display: grid;
  grid-template-columns: 1fr 1200px 1fr; 
  gap: 0; 
    margin-top: 40px;
}

.home_part4left, .home_part4right {
    
}

.home_part4_1 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
    align-items: center; /* 水平居中 */
    background-color: #ffffff;
}
.home_part4_1_1, .home_part4_1_2 {
    width: 100%;
    text-align: center; /* 文字居中对齐 */
}

.home_part4_1_1 {
    flex: 1;
    justify-content: center;
    align-items: center;
}
.home_part4_1_1_d{
  font-family: Arial;
font-size: 18px;
font-weight: 400;
line-height: 30px;
text-align: left;
margin-left: 8.3%;
width:83%;
}
.home_part4_1_1_d_button{
  display: flex;
  margin-left: 8.3%;
  margin-top: 8%;
}
.jiantou{
  margin-left: -30px;
  margin-top: 5px;
}
.home_part4_1_2 {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
}

.home_part4_1_2 img {
    max-width: 100%;
    height: auto; /* 确保图片按比例缩放 */
}

.home_part5 {
  display: grid;
  grid-template-columns: 1fr 1200px 1fr; 
  gap: 0; 
    margin-top: 40px;
}

.home_part5left, .home_part5right {
    flex: 1; /* 左右部分占剩余空间的相等比例 */
}

.home_part5_1 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
    align-items: center; /* 水平居中 */
    justify-content: space-between;
    background-color: #ffffff;
}

.home_part5_1_1{
    flex: 1; /* 使图片和文字部分各占50%的宽度 */
    display: flex;
    justify-content: center;
    align-items: center;

}
.home_part5_1_2{
    flex: 1; 
    justify-content: center;
    align-items: center;

}
.home_part5_1_1 {
    text-align: center; /* 图片居中对齐 */
}

.home_part5_1_2_d {
    text-align: left; /* 文字左对齐 */
    width: 76%;
    margin-left: 13%;
    color: #1B2944;
    font-family: Arial;
    font-size: 18px;
    font-weight: 400;
    line-height: 30px;
}

.home_part5_1_2_button {
  display: flex;
  margin-left: 13%;
  margin-top: 8%;
}

.home_part6{
  position: relative;
  width: 100%;
  overflow: hidden;
  margin-top: 50px;
}
.home_part6_image{
  width: 100%;
  height: 100%;
  object-fit: cover;
}
  </style>